import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import SEO from './seo'
import Nav from './nav'

import '../styles/base.sass'

const Layout = ({
    title,
    description,
    socialImage,
    section,
    showNav = true,
    navClassName,
    search,
    children,
    className,
}) => (
    <>
        <SEO title={title} description={description} section={section} image={socialImage} />
        <StaticQuery
            query={query}
            render={({ site }) => {
                const { navigation } = site.siteMetadata
                return (
                    <main className={className}>
                        {showNav && (
                            <Nav items={navigation} className={navClassName} search={search} />
                        )}
                        {children}
                    </main>
                )
            }}
        />
    </>
)

const query = graphql`
    query {
        site {
            siteMetadata {
                navigation {
                    text
                    url
                    blank
                    menu {
                        main {
                            text
                            label
                            url
                        }
                    }
                }
            }
        }
    }
`

export default Layout
